import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip as ChartTooltip, BarElement, } from 'chart.js';
export function createCategoryChartContainer(controller, View) {
    ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ChartTooltip);
    return (containerProps) => {
        const [state, setState] = useState({
            visible: containerProps.datasets.map((item) => item.key),
        });
        const props = controller.useProps({
            ...containerProps,
            legend: {
                datasets: containerProps.datasets,
                visible: {
                    value: state.visible,
                    onChange(value) {
                        setState({ ...state, visible: value });
                    },
                },
            },
        });
        return _jsx(View, { ...props });
    };
}
//# sourceMappingURL=categoryContainer.js.map